import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	forwardRef,
	HostBinding,
	inject,
	Input,
	Output,
	ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormBuilder } from "@angular/forms";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => TextCellInputComponent),
	multi: true,
};

@Component({
	selector: "ic-text-input-cell",
	styleUrls: ["./text-cell.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./text-cell.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TextCellInputComponent implements ControlValueAccessor {
	private cdRef = inject(ChangeDetectorRef);
	private formBuilder = inject(UntypedFormBuilder);
	private eRef = inject(ElementRef);

	disabled = false;
	form = this.formBuilder.group({
		value: [""],
	});

	@Input() errorText = "";
	@Input() placeholder = "";

	@Output() blurEvent = new EventEmitter();
	@Output() focusEvent = new EventEmitter();

	@ViewChild("input", { static: true }) input: ElementRef;

	@HostBinding("attr.tabIndex") tabIndex = 0;
	@HostBinding("class.is-hidden") hideLabel = true;
	@HostBinding("class.error") @Input() error = false;

	writeValue(value: string) {
		this.form.patchValue({ value });
		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onModelChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	setDisabledState(isDisabled: boolean) {
		if (isDisabled) {
			this.form.disable();
		} else {
			this.form.enable();
		}

		this.disabled = isDisabled;
		this.cdRef.markForCheck();
	}

	onChange() {
		this.onTouch();
		this.onModelChange(this.form.get("value").value);
	}

	onBlurred() {
		this.hideLabel = true;
		this.cdRef.markForCheck();
		this.onTouch();
		this.blurEvent.emit();
	}

	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onModelChange = (_: unknown) => {}; // eslint-disable-line @typescript-eslint/no-empty-function
}
